import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";

const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

// Protection CSRF maison : le helper du framework tire une dépendance
// serveur (node:async_hooks) dans le bundle navigateur et casse l'hydratation.
// On vérifie simplement l'origine des requêtes mutatives vers les server fns.
const csrfMiddleware = createMiddleware().server(async ({ next, request }) => {
  const method = request?.method?.toUpperCase();
  if (request && method && !["GET", "HEAD", "OPTIONS"].includes(method)) {
    const origin = request.headers.get("origin");
    if (origin) {
      try {
        if (new URL(origin).host !== new URL(request.url).host) {
          return new Response("Forbidden", { status: 403 });
        }
      } catch {
        return new Response("Forbidden", { status: 403 });
      }
    }
  }
  return await next();
});

export const startInstance = createStart(() => ({
  requestMiddleware: [errorMiddleware, csrfMiddleware],
}));